import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AuthShell({ children, side = "checklist", title, subtitle }) {
    const sideImg = {
        checklist: { img: "/panda/panda-checklist.png", quote: "\"We ticked every box on your behalf. Twice.\"" },
        virtual: { img: "/panda/panda-virtual.png", quote: "\"Log in. Log savings.\"" },
    }[side];

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
            <div className="flex items-center justify-center px-6 py-10 lg:py-16">
                <div className="w-full max-w-md">
                    <Link
                        to="/"
                        data-testid="auth-back"
                        className="inline-flex items-center gap-2 text-sm text-navy-500 hover:text-navy-700 mb-10"
                    >
                        <ArrowLeft size={15} /> Back to Perx Group
                    </Link>
                    <div className="flex items-center gap-3 mb-8">
                        <img src="/perx_logo.png" className="h-9 w-9" alt="" />
                        <div className="font-display text-xl text-navy-700">
                            Perx Group
                        </div>
                    </div>
                    <h1 className="font-display text-4xl md:text-5xl text-navy-700 mb-3 leading-tight">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-navy-500 mb-8">{subtitle}</p>
                    )}
                    {children}
                </div>
            </div>

            <div className="hidden lg:block relative bg-navy-700 overflow-hidden">
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "radial-gradient(circle at 30% 30%, rgba(212,175,55,0.25) 0%, rgba(0,28,80,0) 55%)",
                    }}
                />
                <div className="relative z-10 h-full flex flex-col items-center justify-center px-12">
                    <img
                        src={sideImg.img}
                        alt=""
                        className="max-h-[420px] object-contain drop-shadow-2xl"
                    />
                    <p className="mt-8 font-display text-2xl text-white text-center max-w-sm leading-snug">
                        {sideImg.quote}
                    </p>
                    <p className="mt-4 text-xs uppercase tracking-[0.4em] text-gold-500">
                        — the Perx panda
                    </p>
                </div>
            </div>
        </div>
    );
}
